
// imported in base router.ts
export default
	[
		{
			path: "/website/:id",
			name: "website",
			component: () => import("@/Views/Domain/ParticaWebsite.vue"),
			props: true,
			children: [
			],
			meta: { name: "Website", page: "website" }
		},
		{
			path: "/websitesecurity/:id",
			name: "websitesecurity",
			component: () => import("@/Views/Domain/ParticaWebsiteSecurity.vue"),
			props: true,
			children: [
			],
			meta: { name: "Website", page: "website" }
		},
		{
			path: "/title/:id/",
			name: "title",
			component: () => import("@/Views/Domain/ParticaTitle.vue"),
			props: true,
			children: [
			],
			meta: { name: "Title", page: "publication" }
		},
		{
			path: "/scheduledtasks/:id/",
			name: "scheduledtasks",
			component: () => import("@/Views/Domain/Title/ScheduledTasks.vue"),
			props: true,
			children: [
			],
		},
		{
			path: "/pubissue/:id/",
			name: "issue",
			component: () => import("@/Views/Domain/ParticaIssue.vue"),
			props: true,
			children: [
			],
			meta: { name: "Issue", page: "issue" }
		},
		{
			path: "/issueextraction/:id/",
			name: "issueextraction",
			component: () => import("@/Views/Domain/Issue/IssueExtractionV2.vue"),
			props: true,
			children: [
			],
			meta: { name: "PDF extraction", page: "issue" }
		},
		{
			path: "/issuepagewordsmart/:id/",
			name: "issuepagewordsmart",
			component: () => import("@/Views/Domain/Issue/IssuePageWordsmart.vue"),
			props: true,
			children: [
			],
			meta: { name: "Wordsmart", page: "issue" }
		},
		{
			path: "/issuecreatepdf/:id/",
			name: "issuecreatepdf",
			component: () => import("@/Views/Domain/Issue/IssueCreatePdf.vue"),
			props: true,
			children: [
			],
			meta: { name: "Create Issue via PDF", page: "publication" }
		},
		{
			path: "/issuecreatemultiplepdf/:id/",
			name: "issuecreatemultiplepdf",
			component: () => import("@/Views/Domain/Issue/IssueCreateMultiplePdf.vue"),
			props: true,
			children: [
			],
			meta: { name: "Create Issue via PDF", page: "publication" }
		},
		{
			path: "/issueconversion/:id/",
			name: "issueconversion",
			component: () => import("@/Views/Domain/Issue/IssueConversion.vue"),
			props: true,
			children: [
			],
			meta: { name: "Issue Conversion Log", page: "issue" }
		},
		{
			path: "/issueviewweconfig/:id/",
			name: "issueviewerconfig",
			component: () => import("@/Views/Domain/Issue/IssueViewerConfiguration.vue"),
			props: true,
			children: [
			],
			meta: { name: "Issue Folio", page: "issue" }
		},
		{
			path: "/issuefolio/:id/",
			name: "issuefolio",
			component: () => import("@/Views/Domain/Issue/IssueFolio.vue"),
			props: true,
			children: [
			],
			meta: { name: "Issue Folio", page: "issue" }

		}, {
			path: "/issuepdfreplace/:id/",
			name: "issuepdfreplace",
			component: () => import("@/Views/Domain/Issue/IssuePdfReplace.vue"),
			props: true,
			children: [
			],
			meta: { name: "Replace Source PDF", page: "issue" }
		},
		{
			path: "/issuetoc/:id/",
			name: "issuetoc",
			component: () => import("@/Views/Domain/Issue/IssueTOC.vue"),
			props: true,
			children: [
			],
			meta: { name: "Table Of Contents", page: "issue" }
		},
		{
			path: "/issuemanagearticles/:id/",
			name: "issuemanagearticles",
			component: () => import("@/Views/Domain/Issue/IssueManageArticles.vue"),
			props: true,
			children: [
			],
			meta: { name: "Manage Articles", page: "issue" }
		},
		{
			path: "/issuemanagemeta/:id/",
			name: "issuemanagemeta",
			component: () => import("@/Views/Domain/Issue/IssueManageMetadata.vue"),
			props: true,
			children: [
			],
			meta: { name: "Manage Metadata", page: "issue" }
		},
		{
			path: "/issuestatus/:id/",
			name: "issuestatus",
			component: () => import("@/Views/Domain/Issue/IssueStatus.vue"),
			props: true,
			children: [
			],
			meta: { name: "Manage Metadata", page: "issue" }
		},
		{
			path: "/sectionmanager/:id/",
			name: "sectionmanager",
			component: () => import("@/Views/Domain/Title/SectionManager.vue"),
			props: true,
			children: [
			],
			meta: { name: "Section Manager", page: "publication" }
		},
		{
			path: "/publicationlog/:id/",
			name: "publicationlog",
			component: () => import("@/Views/Domain/Title/PublicationLog.vue"),
			props: true,
			children: [
			],
			meta: { name: "Section Manager", page: "publication" }
		}, {
			path: "/metadataimport/:id/",
			name: "metadataimport",
			component: () => import("@/Views/Domain/Title/MetadataImport.vue"),
			props: true,
			children: [
			],
			meta: { name: "Import Metadata", page: "publication" }
		},
		{
			path: "/websiteusers/:id/",
			name: "websiteusers",
			component: () => import("@/Views/Domain/Users/UserManagement.vue"),
			props: true,
			children: [
			],
			meta: { name: "User Management", page: "website" }
		}

	];
